/**
 * Keep keys in sync with backend/constants/jobTrackingStages.js
 */

export const TRACKING_STAGE_ORDERED_KEYS = [
  "job_created",
  "move_scheduled",
  "team_packing_arrived",
  "goods_loaded",
  "truck_departed_origin",
  "in_transit",
  "warehouse_storage",
  "truck_arrived_destination",
  "unloaded",
  "unpacked_rearranged",
  "completed",
];

export const TRACKING_STAGE_LABELS = {
  job_created: "Job created",
  move_scheduled: "Move scheduled",
  team_packing_arrived: "Team arrived for packing",
  goods_loaded: "Goods loaded",
  truck_departed_origin: "Truck departed origin",
  in_transit: "In transit",
  warehouse_storage: "Warehouse / storage",
  truck_arrived_destination: "Truck arrived at destination",
  unloaded: "Unloaded",
  unpacked_rearranged: "Unpacked & rearranged",
  completed: "Completed",
};

export function labelForStage(key) {
  return TRACKING_STAGE_LABELS[key] || key || "—";
}
